import React from "react";
import { useRouter } from "next/router";

const EmailCheckGuide = () => {
  const router = useRouter();

  const handleOkButton = () => {
    router.push("/user/market");
  };
  return (
    <div className="flex items-center auth pt-5 pb-20 login-bg">
      <div className="row w-100 mx-0 h-full">
        <div className="col-12 col-md-8 col-xl-4 mx-auto">
          <div className="text-left py-5 px-4">
            <h1 className="text-center mb-5 sign-font">AISO</h1>
            <h4 className="text-blue-500">이메일 인증을 완료해 주세요!</h4>
            <h5 className="text-888 mb-0">가입하신 이메일로 인증메일이 발송되었습니다.</h5>
            <h5 className="text-888">인증 완료 후 정상적인 서비스 이용이 가능합니다</h5>
            <div className="mt-4 shadow-md">
              <button type="button" className="btn btn-block btn-primary auth-form-btn" onClick={handleOkButton}>
                확인
              </button>
            </div>
          </div>
          <div className="center">
            <img src="/images/header/img-logo-full@3x.png" alt="logo" className="w-2/12" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailCheckGuide;
